import React from "react";
import i18n from "../../../../constants/i18n";
import { getSelectedEventData } from "../../../../helpers/et3-get-selected-event-data";
import getTBWStore from "../../../../stores/developer-store/tbw-store";
import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";
import Et3Button from "../../../et3-button";
import { withLiteObserverAndTheme } from "../../../et3-enhanced-render";
import ET3Div from "../../../et3-div";
import Et3Text from "../../../et3-text";
import Et3ATag from "../../../et3-a-tag";
import { TTBWExtraData } from "../../../../Types";
import Et3Picker from "../../../et3-input/et3-picker";
import { TEt3PickerMultipleValue } from "../../../../TypesNEW";
import { reduce } from "et3-type-guards";

const AuditReasonsPopUp = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const data = getTBWStore()
    .TBWreasons.get()
    .map((reason) => {
      return { label: reason.tbwName, value: reason.id.toString() };
    });
  const status = getTBWStore().TBWAuditIssue.get();
  const { eventIDNumber } = getSelectedEventData();
  const userID = getUserAdvancedStore().currentUserId.get();
  const userUUID = reduce(
    () => getUserAdvancedStore().userData.get(userID).userUUID,
    ""
  );
  const userUUIDforTBW: TTBWExtraData = {
    userID,
    userUUID,
    reportedUUID: "",
    reportID: -1,
    reportedID: -1,
    secondPartyID: -1
  };
  const isEnabled = getTBWStore().saveTbwReasonsIsEnabled.get();

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={300}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          style={{}}
          label=""
          options={data}
          value={getTBWStore().getTWBReasonSelectValue()}
          onClick={() => {}}
          onChoose={(value: TEt3PickerMultipleValue) => {
            getTBWStore().setTBWReasons(value);
          }}
          isMultiple={true}
          onEnter={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="space-around"
        alignItems="center"
        withShadow={false}
        width={1000}
        height={100}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Button
          isEnabled={isEnabled}
          onClick={async () => {
            getTBWStore().TBWSaveButtonDisabled.set(true);
            await getTBWStore().showActionTBWPopUp({
              type: "AUDIT_PROOF",
              headerMessage: i18n.get("PROOF_MINOR_MAJOR"),
              actionName: "",
              fromPage: "AUDITOR_AUDIT",
              extraData: userUUIDforTBW,
              eventId: eventIDNumber,
              issueAudit: status
            });
          }}
          size="MEDIUM"
          text="SAVE"
          type="APPROVE"
        />
        <Et3ATag
          href={`/auditor/TBWReasons`}
          target="_blank"
          style={{
            color: `${colors.all.lavenderIndigo}`
          }}
        >
          <Et3Text
            fontFamily={"BOLD"}
            fontSize={20}
            text={i18n.get("ADD_REMOVE")}
            isSpan={false}
            color={colors.all.bondiBlue}
            style={{}}
          />
        </Et3ATag>
      </ET3Div>
    </React.Fragment>
  );
});
export default AuditReasonsPopUp;
